module.exports = __webpack_public_path__ + "img/257f416.svg";